export const environment = {
  production: false,
  name: "development",
  serverUrl: "https://services-dev.revolab.tech/api/dashboard",
  siteUrl: "https://dev.revolab.tech/dashboard",
  recaptchaSiteKey: "6LcVYGcpAAAAADUGxIT-kA6CQaIVwssHplrtEraT",
  syncTranslations: true,
  company: 'revolab',
  platform: 'revolab-dashboard',
};
